export default "__VITE_ASSET__BNQgx54f__"